import { loadScriptInHead } from '../../utils/dom';
import { GEOLOCATION_AU } from '../../../js/constants';

/**
 * Unique ID provided for GTM environment.
 *
 * @param {string}  geolocation
 * @const {string}
 */
 export const getGTMContainerID = (geolocation) => geolocation === GEOLOCATION_AU ? 'GTM-MKCK9FM' : 'GTM-PBVC7CQ';

/**
 * Loads GTM script in head.
 *
 * @param {string}  geolocation
 * @param {boolean} onProduction
 */
const loadGTM = (geolocation: string) => {
  const _dataLayer = window._dataLayer || (window._dataLayer = []);
  _dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });
  loadScriptInHead(
    'marketing',
    `https://www.googletagmanager.com/gtm.js?id=${getGTMContainerID(geolocation)}&l=_dataLayer`
    );
};

/**
 * Compiles the <iframe> script for gtm loading and prepends it to the <body>.
 *
 * @param {string}  geolocation
 * @param {boolean} onProduction
 */
const addGTMIframeToBody = (geolocation: string) => {
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.height = iframe.width = 0;
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${getGTMContainerID(geolocation)}`;
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.prepend(noscript);
};

/**
 * Initializes all necessary GTM resources.
 *
 * @param {Object}  edition_data
 * @param {Object}  document
 * @param {boolean} onProduction
 */
export default (edition_data: Object, document: Object, onProduction: boolean, geolocation: string) => {
  loadGTM(geolocation);
  addGTMIframeToBody(geolocation, onProduction);
};
